import { combineReducers } from 'redux'

import cardsdestinosReducer, { ICardsdestinosState, initialCardsdestinosState } from './cardsdestinosReducer'
import cardsinstagramReducer, { ICardsinstagramState, initialCardsinstagramState } from './cardsinstagramReducer'
import cardspartnersReducer, { ICardspartnersState, initialCardspartnersState } from './cardspartnersReducer'
import cardspressReducer, { ICardspressState, initialCardspressState } from './cardspressReducer'
import cardstourdesksReducer, { ICardstourdesksState, initialCardstourdesksState } from './cardstourdesksReducer'
import carouseltoppagesReducer, { ICarouseltoppagesState, initialCarouseltoppagesState } from './carouseltoppagesReducer'
import contactsReducer, { IContactsState, initialContactsState } from './contactsReducer'
import seccionfinanzasReducer, { initialSeccionfinanzasState, ISeccionfinanzasState } from './seccionfinanzasReducer'
import seccionitsReducer, { initialSeccionitsState, ISeccionitsState } from './seccionitsReducer'
import seccionmarketingsReducer, { initialSeccionmarketingsState, ISeccionmarketingsState } from './seccionmarketingsReducer'
import seccionsociosReducer, { initialSeccionsociosState, ISeccionsociosState } from './seccionsociosReducer'
import seccionturismosReducer, { initialSeccionturismosState, ISeccionturismosState } from './seccionturismosReducer'
import toppagesaboutusReducer, { initialToppagesaboutusState, IToppagesaboutusState } from './toppagesaboutusReducer'
import toppagesjoinusReducer, { initialToppagesjoinusState, IToppagesjoinusState } from './toppagesjoinusReducer'
import toppagespressReducer, { initialToppagespressState, IToppagespressState } from './toppagespressReducer'
import usersReducer, { initialUsersState, IUsersState } from './usersReducer'

export interface IState {
  users: IUsersState
  cardsdestinos: ICardsdestinosState
  cardstourdesks: ICardstourdesksState
  seccionsocios: ISeccionsociosState
  cardspress: ICardspressState
  contacts: IContactsState
  cardsinstagram: ICardsinstagramState
  seccionmarketings: ISeccionmarketingsState
  seccionits: ISeccionitsState
  seccionturismos: ISeccionturismosState
  seccionfinanzas: ISeccionfinanzasState
  cardspartners: ICardspartnersState
  carouseltoppages: ICarouseltoppagesState
  toppagespress: IToppagespressState
  toppagesjoinus: IToppagesjoinusState
  toppagesaboutus: IToppagesaboutusState
}

export const initialState: IState = {
  users: initialUsersState,
  cardsdestinos: initialCardsdestinosState,
  cardstourdesks: initialCardstourdesksState,
  seccionsocios: initialSeccionsociosState,
  cardspress: initialCardspressState,
  contacts: initialContactsState,
  cardsinstagram: initialCardsinstagramState,
  seccionmarketings: initialSeccionmarketingsState,
  seccionits: initialSeccionitsState,
  seccionturismos: initialSeccionturismosState,
  seccionfinanzas: initialSeccionfinanzasState,
  cardspartners: initialCardspartnersState,
  carouseltoppages: initialCarouseltoppagesState,
  toppagespress: initialToppagespressState,
  toppagesjoinus: initialToppagesjoinusState,
  toppagesaboutus: initialToppagesaboutusState,
}

export default combineReducers({
  users: usersReducer,
  cardsdestinos: cardsdestinosReducer,
  cardstourdesks: cardstourdesksReducer,
  seccionsocios: seccionsociosReducer,
  cardspress: cardspressReducer,
  contacts: contactsReducer,
  cardsinstagram: cardsinstagramReducer,
  seccionmarketings: seccionmarketingsReducer,
  seccionits: seccionitsReducer,
  seccionturismos: seccionturismosReducer,
  seccionfinanzas: seccionfinanzasReducer,
  cardspartners: cardspartnersReducer,
  carouseltoppages: carouseltoppagesReducer,
  toppagespress: toppagespressReducer,
  toppagesjoinus: toppagesjoinusReducer,
  toppagesaboutus: toppagesaboutusReducer,
})
